import React from 'react';
import { Row, Col } from 'antd';
import { Draggable } from 'react-beautiful-dnd';
import { DragOutlined, DeleteOutlined } from '@ant-design/icons';

import OnTraccrTextInput from '../../common/inputs/OnTraccrTextInput';
import BorderlessButton from '../../common/buttons/BorderlessButton';

const OptionRow = ({
  option,            
  index,            
  columns,          
  onDelete,
  onChange,
}) => (
  <Draggable draggableId={option.id.toString()} index={index}>
    {(prov) => (
      <div
        ref={prov.innerRef}
        {...prov.draggableProps}
        className="options-row"         
      >
        <Row gutter={10} align="middle">
          <Col flex="18px">
            <Row
              justify="center"
              align="middle"
              style={{ height: '100%', paddingRight: 5 }}
            >
              <DragOutlined
                {...prov.dragHandleProps} 
                className="options-row-dragger"
              />
            </Row>
          </Col>
          {columns.map(({ key }) => (
            <Col flex="auto" key={`${key}-${option.id}`}>
              <OnTraccrTextInput
                textarea
                value={option[key]}
                onChange={onChange({ key, id: option.id })}
              />
            </Col>
          ))}

          <Col flex="30px">
            <BorderlessButton
              iconNode={<DeleteOutlined style={{ margin: 0, color: 'red' }} />}
              onClick={onDelete(option.id)}
            />
          </Col>
        </Row>
      </div>
    )}
  </Draggable>
);

export default OptionRow;
